import React from 'react';
import { Package, FileText, Users, AlertTriangle } from 'lucide-react';
export function EssentialMetrics() {
  const metrics = [{
    title: 'Products Monitored',
    value: '1,247',
    description: '89 pending review',
    icon: Package,
    color: 'purple'
  }, {
    title: 'Active Claims',
    value: '834',
    description: '156 require validation',
    icon: FileText,
    color: 'purple'
  }, {
    title: 'Suppliers Monitored',
    value: '126',
    description: '12 new this month',
    icon: Users,
    color: 'purple'
  }, {
    title: 'Compliance Issues',
    value: '23',
    description: '8 high priority',
    icon: AlertTriangle,
    color: 'purple'
  }];
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-61">
      {metrics.map((metric, index) => <div key={index} className="bg-white rounded-lg border p-6" data-id="element-62">
          <div className="flex items-center justify-between mb-4" data-id="element-63">
            <div className="p-3 rounded-lg bg-purple-50" data-id="element-64">
              <metric.icon className="w-6 h-6 text-purple-600" data-id="element-65" />
            </div>
          </div>
          <p className="text-3xl font-bold text-gray-900 mb-2" data-id="element-66">
            {metric.value}
          </p>
          <p className="text-sm text-gray-600 mb-1" data-id="element-67">{metric.title}</p>
          <p className="text-xs text-purple-600" data-id="element-68">{metric.description}</p>
        </div>)}
    </div>;
}